module.exports = __webpack_public_path__ + "img/liushui (3).3cab827e.png";